import Academy from '../Readings/Academy_HTB.md';
import Active from '../Readings/Active_HTB.md';
import Archetype from '../Readings/Archetype_HTB.md';
import Armageddon from '../Readings/Armageddon_HTB.md';
// import Backdoor from '../Readings/Backdoor_HTB.md';
import Bastion from '../Readings/Bastion_HTB.md';
import Blunder from '../Readings/Blunder_HTB.md';
import BountyHunter from '../Readings/BountyHunter_HTB.md';
import Buff from '../Readings/Buff_HTB.md';
import Cap from '../Readings/Cap_HTB.md';
import Delivery from '../Readings/Delivery_HTB.md';
import DevOops from '../Readings/DevOops_HTB.md';
import Doctor from '../Readings/Doctor_HTB.md';
import Driver from '../Readings/Driver_HTB.md';
import Dynstr from '../Readings/Dynstr_HTB.md';
import Enterprise from '../Readings/Enterprise_HTB.md';
import Explore from '../Readings/Explore_HTB.md';
import Forest from '../Readings/Forest_HTB.md';
import Forge from '../Readings/Forge_HTB.md';
import Heist from '../Readings/Heist_HTB.md';
import Horizontall from '../Readings/Horizontall_HTB.md';
import Intelligence from '../Readings/Intelligence_HTB.md';
import Knife from '../Readings/Knife_HTB.md';
import Laboratory from '../Readings/Laboratory_HTB.md';
import Love from '../Readings/Love_HTB.md';
import Luanne from '../Readings/Luanne_HTB.md';
import Oopsie from '../Readings/Oopsie_HTB.md';
import OpenAdmin from '../Readings/OpenAdmin_HTB.md';
// import Pandora from '../Readings/Pandora_HTB.md';
import Previse from '../Readings/Previse_HTB.md';
import Sauna from '../Readings/Sauna_HTB.md';
import ScriptKiddie from '../Readings/ScriptKiddie_HTB.md';
import Seal from '../Readings/Seal_HTB.md';
// import Secret from '../Readings/Secret_HTB.md';
import Shocker from '../Readings/Shocker_HTB.md';
import Spectra from '../Readings/Spectra_HTB.md';
import Time from '../Readings/Time_HTB.md';
import Traverxec from '../Readings/Traverxec_HTB.md';
import Writer from '../Readings/Writer_HTB.md';
import WriteUp from '../Readings/WriteUp_HTB.md';
import TIWAP_Easy from '../Readings/TIWAP_Easy.md';
import TIWAP_Medium from '../Readings/TIWAP_Medium.md';
import TIWAP_Hard from '../Readings/TIWAP_Hard.md';

const blog_files = {
    "academy": Academy,
    "active": Active,
    "archetype": Archetype,
    "armageddon": Armageddon,
    // "backdoor": Backdoor,
    "bastion": Bastion,
    "blunder": Blunder,
    "bountyHunter": BountyHunter,
    "buff": Buff,
    "cap": Cap,
    "delivery": Delivery,
    "devoops": DevOops,
    "doctor": Doctor,
    "driver": Driver,
    "dynstr": Dynstr,
    "enterprise": Enterprise,
    "explore": Explore,
    "forest": Forest,
    "forge": Forge,
    "heist": Heist,
    "horizontall": Horizontall,
    "intelligence": Intelligence,
    "knife": Knife,
    "laboratory": Laboratory,
    "love": Love,
    "luanne": Luanne,
    "oopsie": Oopsie,
    "openAdmin": OpenAdmin,
    // "pandora": Pandora,
    "previse": Previse,
    "sauna": Sauna,
    "scriptKiddie": ScriptKiddie,
    "seal": Seal,
    // "secret": Secret,
    "shocker": Shocker,
    "spectra": Spectra,
    "time": Time,
    "traverxec": Traverxec,
    "writer": Writer,
    "writeup": WriteUp,
    "tiwapLow": TIWAP_Easy,
    "tiwapMedium": TIWAP_Medium,
    "tiwapHard": TIWAP_Hard
};

export default blog_files;